import LoadingBackdrop from 'components/LoadingBackdrop'
import React, { useContext, useEffect, useMemo } from 'react'
import { isMobile } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import { useExpanded, usePagination, useTable } from 'react-table'
import { useSticky } from 'react-table-sticky'
import TableHeader from 'routes/Transits/Table/TableHeader'
import { TablePagination } from 'routes/Transits/Table/TablePagination'
import { ISelectOption } from 'types/IClassifier'
import { NotificationContext } from '../../../context/NotificationContext'
import { getCustomerStatusOptions, getTableHeaders } from '../config'
// eslint-disable-next-line import/no-cycle
import { useCustomersPage } from '../hooks/useCustomersPage'
import TableBody from './TableBody'

function Table() {
  const {
    t,
    i18n,
  } = useTranslation()

  const columns = useMemo(() => getTableHeaders(t), [i18n.language])
  const {
    data,
    loading,
    filtersState,
    typeFilter,
    setTypeFilter,
    totalPages,
    setCurrentPageSize,
    setCurrentPageIndex,
    refreshPage,
    customerCountsData,
  } = useCustomersPage({
    pageIndex: 0,
    pageSize: 50,
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    gotoPage: openPage,
  })

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,

    // PAGINATION
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: {
      pageIndex,
      pageSize,
    },
  } = useTable(
    {
      /* @ts-ignore */
      columns,
      data,
      initialState: {
        pageIndex: 0,
        pageSize: 50,
      },
      manualPagination: true,
      pageCount: totalPages,
    },
    useExpanded,
    useSticky,
    usePagination,
  )

  function openPage(index: number) {
    gotoPage(index)
  }

  useEffect(() => {
    setCurrentPageIndex(pageIndex)
  }, [pageIndex])
  useEffect(() => {
    setCurrentPageSize(pageSize)
  }, [pageSize])

  const [filters, setFilters] = filtersState

  const typeOptions: ISelectOption[] = getCustomerStatusOptions()

  const { contextHeaderNotificationMessage } = useContext(NotificationContext)

  return (
    <>
      <div
        className={`table__container table-responsive customer-table__container ${isMobile ? 'not-in-mobile' : ''} ${contextHeaderNotificationMessage !== '' ? 'notification--open' : ''}`}
      >
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <table {...getTableProps()} className="table sticky table-hover fixed-columns mb-0">
          <TableHeader
            selectFilterOptions={typeOptions}
            /* @ts-ignore */
            headerGroups={headerGroups}
            filterState={{
              filters,
              setFilters,
            }}
            selectFilterState={{
              selectFilter: typeFilter,
              setSelectFilter: setTypeFilter,
            }}
          />
          <TableBody
            isLoading={loading}
            /* @ts-ignore */
            page={page}
            prepareRow={prepareRow}
            getTableBodyProps={getTableBodyProps}
            customerCountsData={customerCountsData}
            refreshPage={refreshPage}
          />
          <LoadingBackdrop loading={loading} />
        </table>
      </div>
      <TablePagination
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        pageOptions={pageOptions}
        pageCount={pageCount}
        gotoPage={gotoPage}
        nextPage={nextPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
        pageIndex={pageIndex}
        pageSize={pageSize}
      />
    </>
  )
}

export default Table

